module.exports = __webpack_public_path__ + "static/media/manuelle-lymphdrainage-desktop.30e6e7a8.jpg";